import LessonProgressDashboardStats from '@/models/LessonProgressDashboardStats';
import toNeighbors, { Neighbors } from '@/utils/shared/toNeighbors';

export type LessonNeighbors = Neighbors<LessonProgressDashboardStats>;

const isScheduled = (lessonProgress: LessonProgressDashboardStats) =>
  lessonProgress.scheduledLessonOrder !== null;

export default function toLessonNeighbors(
  lessonProgresses: LessonProgressDashboardStats[],
  lessonId: number,
): LessonNeighbors {
  return toNeighbors({
    items: lessonProgresses,
    isCurrent: ({ lesson }) => lesson.id === lessonId,
    isNavigable: isScheduled,
  });
}
